import { format as formatBase } from 'date-fns'

export function format(locale: Locale) {
  return (firstDate: Date, formatStr: string) =>
    formatBase(firstDate, formatStr, {
      locale,
    })
}
